import { render, staticRenderFns } from "./DashBoardView.vue?vue&type=template&id=0d9098c8"
import script from "./DashBoardView.vue?vue&type=script&lang=js"
export * from "./DashBoardView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports